module.exports = __webpack_public_path__ + "static/media/profileImage.28868fe4.jpg";